import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '@/components/Seo';
import { useGroundingSchemas } from '@/lib/useGroundingSchemas';
import { ArrowLeft } from 'lucide-react';

export default function CPICPAPPIVergleichPage() {
  const [htmlContent, setHtmlContent] = useState('');
  useGroundingSchemas(htmlContent, {
    headline: 'CPI vs CPA vs PPI: Abrechnungsmodelle im Vergleich 2026',
    description: 'CPI, CPA oder PPI? Kompletter Vergleich der App-Marketing Abrechnungsmodelle: Unterschiede, Vorteile, Kosten und Empfehlungen.',
    path: '/cpi-cpa-ppi-vergleich',
  });

  useEffect(() => {
    fetch('/grounding-pages/cpi-cpa-ppi-vergleich.html')
      .then(res => res.text())
      .then(html => {
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        if (bodyMatch) setHtmlContent(bodyMatch[1]);
      })
      .catch(err => console.error('Error loading grounding page:', err));
  }, []);

  return (
    <>
      <Seo
        title="CPI vs CPA vs PPI: Abrechnungsmodelle im Vergleich 2026"
        description="CPI, CPA oder PPI? Kompletter Vergleich der App-Marketing Abrechnungsmodelle: Unterschiede, Vorteile, Kosten und Empfehlungen."
        path="/cpi-cpa-ppi-vergleich"
        ogType="article"
      />

      <nav className="sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-teal-600 transition-colors">
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline">Zurück</span>
            </Link>
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center">
                <span className="text-white font-bold text-sm">✦</span>
              </div>
              <span className="font-bold text-lg">
                mar<span className="text-teal-600">KI</span>pilot
              </span>
            </Link>
          </div>
        </div>
      </nav>

      <div className="grounding-page-content" dangerouslySetInnerHTML={{ __html: htmlContent }} />
      <style jsx>{`.grounding-page-content { max-width: 800px; margin: 0 auto; padding: 40px 24px; }`}</style>
    </>
  );
}